import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["close", "submit", "progress", "error"]

  connect() {
    this.pending = false
    this.modal = $(this.element).closest(".modal")
    this.preventClose = (event) => {
      if (this.pending) event.preventDefault()
    }
    this.modal.on("hide.bs.modal.simcardActivation", this.preventClose)
    this.modal.modal("show")
  }

  start() {
    this.pending = true
    this.element.setAttribute("aria-busy", "true")
    this.closeTargets.forEach((button) => { button.disabled = true })
    this.submitTarget.disabled = true
    this.progressTarget.hidden = false
    this.errorTarget.hidden = true
  }

  finish(event) {
    this.pending = false
    this.element.removeAttribute("aria-busy")
    this.closeTargets.forEach((button) => { button.disabled = false })

    // A Turbo Stream renders the result. Leave uncertain requests disabled to
    // prevent a second activation after a lost connection or unexpected response.
    const contentType = event.detail.fetchResponse?.response.headers.get("content-type") || ""
    if (!contentType.includes("text/vnd.turbo-stream.html") && this.hasErrorTarget) {
      this.progressTarget.hidden = true
      this.errorTarget.hidden = false
    }
  }

  disconnect() {
    this.modal.off("hide.bs.modal.simcardActivation", this.preventClose)
  }
}
